import { Tooltip } from 'antd';
import styles from './index.module.css';

export type MaskedKind =
  | 'email'
  | 'phone'
  | 'employer'
  | 'institution'
  | 'name'
  | 'text';

/**
 * Placeholder text of roughly the shape of the hidden value. Synthetic by
 * construction: the server sent nothing for this field, and this string is
 * what gets blurred, so the DOM never holds anything real to peel back.
 */
export const MASKED_PLACEHOLDER: Record<MaskedKind, string> = {
  email: 'candidate.name@employer-domain.com',
  phone: '+1 (000) 000-0000',
  employer: 'Employer Name Ltd',
  institution: 'University of Somewhere',
  name: 'Firstname Lastname',
  text: 'Hidden in the anonymised view',
};

export const MASKED_LABEL = 'Hidden in the anonymised view';

interface Props {
  kind: MaskedKind;
  /** A tighter blur for table cells. */
  compact?: boolean;
  /** Optional override of the placeholder shape. */
  placeholder?: string;
}

/**
 * A field the server withheld for this viewer (see `Candidate.masked`), drawn
 * as a frosted, grainy value instead of an empty label. Not interactive, not
 * selectable; assistive technology reads the label, not the placeholder.
 */
const MaskedValue = ({ kind, compact = false, placeholder }: Props) => (
  <Tooltip title={MASKED_LABEL}>
    <span
      className={`${styles.masked} ${compact ? styles.compact : ''}`}
      role="img"
      aria-label={MASKED_LABEL}
      data-testid={`masked-${kind}`}
    >
      <span className={styles.text} aria-hidden="true">
        {placeholder ?? MASKED_PLACEHOLDER[kind]}
      </span>
    </span>
  </Tooltip>
);

export default MaskedValue;
